import { Controller } from '@hotwired/stimulus'
import { dispatchCustomEvent } from '../../helpers/custom_events_helper'

// Emits a named PostHog event for the layout's posthog controller to forward. The name and its
// property keys must be registered in helpers/posthog/custom_events.js or the scrub drops it.
export default class extends Controller {
  static values = {
    name: String,
    properties: { type: Object, default: {} },
    onConnect: Boolean,
    once: String
  }

  connect() {
    if (this.onConnectValue) this.capture()
  }

  capture() {
    if (this.hasOnceValue && !this.claimOnce()) return

    dispatchCustomEvent(window, 'posthog:capture', {
      detail: { name: this.nameValue, properties: this.propertiesValue }
    })
  }

  // galette:sidebar:* events fire on window for every drawer; only the one this element wraps counts.
  captureIfOwnSidebar(event) {
    if (this.element.contains(event.detail.sidebar)) this.capture()
  }

  // `once` is a storage key: a banner re-rendered on every page still reports each moment a single time.
  claimOnce() {
    const key = `posthog-event:${this.onceValue}`
    try {
      if (localStorage.getItem(key)) return false

      localStorage.setItem(key, '1')
    } catch {
      // storage unavailable: firing every time beats never firing
    }
    return true
  }
}
